/**
 * WAT-11565 — entry point for the vendored dtv-button (see ./dtv-button.tsx).
 *
 * The webpack alias replaces the WHOLE module, so this file has to re-export
 * everything the published package's index does. `ambient-video-marquee`,
 * `marketing-banner`, `channel-compare-tool-v3` and `genre-preview-tool` import
 * a named type alongside the default; `flip-cards.props.ts` and
 * `dtv-shared-cart/cart-module.tsx` import the type only. A missing runtime
 * export ships `undefined` to every consumer rather than failing the build.
 *
 * Re-exports the dtv-button public API (upstream index @5.0.64). Deliberately
 * not claiming byte-equality with the published index: nothing here can check
 * that, and the guarantee that matters is enforced anyway — a consumer importing
 * a name this file stopped exporting fails the TypeScript compile.
 */
export { DtvButton as default } from "./dtv-button";
export type {
  IDtvButtonVariation,
  IDtvMode,
  IDtvButtonProps,
  IDtvButtonAnalytics
} from "./dtv-button";
